import axios from 'axios'
import moment from 'moment'

import config from '../../config'
import store from '../../store'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import {ELASTIC_TOKEN} from '../../config'

async function elaticsearchQuery(querys) {
  if(!store.state.config) return // store還沒load到config的情況避免npe
  const result = await axios.post(
    encodeURI(`${config.dynamicElaticSearchApi()}<nilometer-*>/_search`),
    querys,
    {
      crossdomain: true,
      headers: {
        authorization: `Basic ${store.state.config.elasticAuthToken}`,
        'content-type': 'application/json'
      }
    }
  )
  return result
}

async function elaticsearchMutiQuery(querys) {
  if(!store.state.config) return // store還沒load到config的情況避免npe
  const result = await axios.post(
    encodeURI(`${config.dynamicElaticSearchApi()}<nilometer-*>/_msearch`),
    querys,
    {
      crossdomain: true,
      headers: {
        authorization: `Basic ${store.state.config.elasticAuthToken}`,
        'content-type': 'application/x-ndjson'
      }
    }
  )
  return result
}

export async function getNilometer(condition = {}) {
  // if (Utils.isEmptyObject(condition)) {
  //   return []
  // }
  const niloIds = Utils.isEmptyObject(condition.identifierId) ? [] : condition.identifierId
  const queryTimeUnit = Utils.isEmptyString(condition.unit) ? 'd' : condition.unit
  const queryTime = Utils.isEmptyObject(condition.value) ? -1 : condition.value
  const startTime = Utils.isEmptyObject(condition.startTime) ? undefined : condition.startTime
  const endTime = Utils.isEmptyObject(condition.endTime) ? undefined : condition.endTime

  const lte = endTime ? moment(endTime) : moment()
  const gte = startTime ? moment(startTime) : moment().subtract(queryTime, queryTimeUnit) // 萬一沒有起訖時間則搜尋一天前

  const query = {
    query: {
      bool: {
        filter: [
          {
            range: { // https://discuss.elastic.co/t/multiple-range-filters-for-same-field/73898/2
              '@timestamp': {
                gte: gte.valueOf(),
                lte: lte.valueOf(),
                format: 'epoch_millis'
              }
            },
          },
          {
            range: {
              'message.data.isLiquid': {
                lt: CONST.HAND_SANITIZER_CRTICAL_POINT
              }
            }
          }
        ]
      }
    },
    sort: {
      '@timestamp': {
        order: 'desc'
      }
    },
    size: CONST.ELK_SEARCH_MAX_SIZE
  }

  // ------filter niloIds id
  if (!Utils.isEmptyObject(niloIds)) {
    const niloIdString = Utils.getESQueryOdorNiloId(niloIds)
    const queryNiloIds = {
      query_string: {
        analyze_wildcard: true,
        query: niloIdString
      }
    }
    query.query.bool.filter.push(queryNiloIds)
  }

  const result = await elaticsearchQuery(query)
  return Utils.isEmptyObject(result)? [] : result.data.hits.hits
}